import React from "react";
import { Link } from "react-router-dom";
import { useReveal } from "@/lib/useReveal";
import { Sparkles, ArrowRight } from "lucide-react";

export default function FinalCTA() {
  const [ref, visible] = useReveal(0.2);
  return (
    <section className="relative overflow-hidden py-24 md:py-28 lm-cv">
      <div className="absolute inset-0 bg-[color:var(--lm-primary)]">
        <div className="lm-parallax lm-parallax-slow absolute -top-20 -left-16 w-[420px] h-[420px] rounded-full bg-white/5 blur-3xl" />
        <div className="lm-parallax lm-parallax-med absolute bottom-[-100px] right-[-60px] w-[380px] h-[380px] rounded-full bg-[color:var(--lm-brand-green)]/15 blur-3xl" />
        <div className="lm-parallax lm-parallax-fast absolute top-[40%] left-[45%] w-[220px] h-[220px] rounded-full bg-[color:var(--lm-secondary)]/12 blur-3xl" />
      </div>
      <div
        ref={ref}
        className={`relative max-w-4xl mx-auto px-5 md:px-10 text-center text-white lm-reveal lm-reveal-scale ${visible ? "is-visible" : ""}`}
      >
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs font-mono uppercase tracking-widest mb-6">
          <Sparkles className="w-3.5 h-3.5" />
          Ready when you are
        </div>
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-display font-bold leading-[1.05] tracking-tight mb-6">
          Stop guessing who your<br />buyer is. Start hearing them.
        </h2>
        <p className="text-lg md:text-xl text-white/75 max-w-2xl mx-auto leading-relaxed mb-10">
          10-minute setup. If a scan finds nothing, <span className="underline decoration-white/40 decoration-2 underline-offset-4">we refund the scan</span>.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/login"
            className="lm-shine-parent inline-flex items-center gap-2 bg-white text-lm-primary px-7 py-4 rounded-lg text-base font-bold hover:bg-[color:var(--lm-brand-green)] transition-colors hover:-translate-y-0.5"
          >
            Get started
            <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
          </Link>
          <a
            href="#pricing"
            className="inline-flex items-center gap-2 border border-white/25 text-white px-7 py-4 rounded-lg text-base font-medium hover:bg-white/10 transition-colors"
          >
            See pricing
          </a>
        </div>
      </div>
    </section>
  );
}
